<div class="main-layout">
  @if (showLandingPageHeader()) {
    <app-navbar/>
  }
  <router-outlet/>
</div>
<!-- <app-footer/> -->
